import PeriodRangeFilter from "@/components/PeriodRangeFilter";

import {
  DATE_FILTER_BUTTON_CLASS,
  FILTER_GROUP_LABELS,
  NSU_FILTER_PLACEHOLDERS,
} from "../constants";
import type { NsuFilterKey, NsuFilterValues } from "../types";
import { normalizeAmount } from "../utils/filter-input";
import { textFilterFactory } from "./text-filter-factory";

interface NsuFiltersProps {
  filters: NsuFilterValues;
  onFilterChange: (key: NsuFilterKey, value: string | undefined) => void;
  periodStart?: string;
  periodEnd?: string;
}

export default function NsuFilters({
  filters,
  onFilterChange,
  periodStart,
  periodEnd,
}: NsuFiltersProps): JSX.Element {
  const textFilter = textFilterFactory(filters, onFilterChange);

  const handleDateChange = (start: string | undefined, end: string | undefined): void => {
    onFilterChange("nsuDateStart", start);
    onFilterChange("nsuDateEnd", end);
  };

  return (
    <div role="group" aria-label={FILTER_GROUP_LABELS.NSU} className="grid grid-cols-2 gap-2">
      <div data-filter="number" className="min-w-0">
        {textFilter("nsuNumber", NSU_FILTER_PLACEHOLDERS.NUMBER)}
      </div>
      <div data-filter="operator" className="min-w-0">
        {textFilter("nsuOperator", NSU_FILTER_PLACEHOLDERS.OPERATOR)}
      </div>
      <div data-filter="date" className="min-w-0">
        <PeriodRangeFilter
          start={filters.nsuDateStart}
          end={filters.nsuDateEnd}
          onChange={handleDateChange}
          label={NSU_FILTER_PLACEHOLDERS.DATE}
          buttonClassName={DATE_FILTER_BUTTON_CLASS}
          minDate={periodStart}
          maxDate={periodEnd}
          inline
        />
      </div>
      <div data-filter="amount" className="min-w-0">
        {textFilter("nsuAmount", NSU_FILTER_PLACEHOLDERS.AMOUNT, normalizeAmount)}
      </div>
    </div>
  );
}
